import AOS from "aos";
import { useEffect, useState } from "react";

const SectionThree = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const data = [
    {
      title: "Company Overview",
      content: (
        <>
          {/* <p>
            <strong>Marichi Tech AI</strong> is a forward-thinking IT company
            based in the USA, dedicated to building impactful digital solutions.
            We specialize in Web Development, Mobile Applications, and Cloud
            Infrastructure that drive innovation and scalability.
          </p> */}
          <div className="education position-relative">
            <div className="side_circle_ring">
              <div className="small_yellow_border">
                <div className="small_yellow_circle"></div>
              </div>
            </div>
            <div className="small_yellow_border_main">
              <p className="bachelor">Established in 2024</p>
              <p className="university">Headquartered in the Nepal</p>
              <p className="cursus">
                With over a decade of industry experience, we help businesses
                navigate digital transformation through cutting-edge, scalable
                technology stacks.
              </p>
            </div>
          </div>
        </>
      ),
    },

    {
      title: "Expertise",
      content: (
        <>
          <p>
            At Marichi Tech AI, we blend design thinking with agile development
            to deliver user-centric, technically robust products.
          </p>
          <div className="education position-relative">
            <div className="side_circle_ring">
              <div className="small_yellow_border">
                <div className="small_yellow_circle"></div>
              </div>
            </div>
            <div className="small_yellow_border_main">
              <p className="bachelor">Custom Software Development</p>
              <p className="university">Full-Stack Engineering</p>
              <p className="cursus">
                Our team is skilled in creating complex platforms from scratch,
                tailored to your exact requirements.
              </p>
            </div>
          </div>
          <div className="education position-relative">
            <div className="side_circle_ring">
              <div className="small_yellow_border">
                <div className="small_yellow_circle"></div>
              </div>
            </div>
            <div className="small_yellow_border_main">
              <p className="bachelor">UI/UX Design</p>
              <p className="university">Figma, Adobe XD, Tailwind CSS</p>
              <p className="cursus">
                Our design team creates seamless, intuitive user experiences
                with a focus on accessibility and branding.
              </p>
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Tech Stack & Systems",
      content: (
        <>
          <p>
            We use a modern and battle-tested technology stack to ensure
            quality, speed, and security across all projects.
          </p>
          <div className="education position-relative">
            <div className="side_circle_ring">
              <div className="small_yellow_border">
                <div className="small_yellow_circle"></div>
              </div>
            </div>
            <div className="small_yellow_border_main">
              <p className="bachelor">Frontend</p>
              <p className="university">React, Vue, Next.js</p>
              <p className="cursus">
                Interactive and responsive user interfaces with excellent
                performance and SEO.
              </p>
            </div>
          </div>
          <div className="education position-relative">
            <div className="side_circle_ring">
              <div className="small_yellow_border">
                <div className="small_yellow_circle"></div>
              </div>
            </div>
            <div className="small_yellow_border_main">
              <p className="bachelor">Backend</p>
              <p className="university">Node.js, Python, PHP</p>
              <p className="cursus">
                Scalable APIs, microservices, and database architecture
                optimized for performance and security.
              </p>
            </div>
          </div>
          <div className="education position-relative">
            <div className="side_circle_ring">
              <div className="small_yellow_border">
                <div className="small_yellow_circle"></div>
              </div>
            </div>
            <div className="small_yellow_border_main">
              <p className="bachelor">DevOps & Cloud</p>
              <p className="university">Docker, Kubernetes, CI/CD</p>
              <p className="cursus">
                Automated deployments, monitoring, and infrastructure as code to
                keep everything running smoothly.
              </p>
            </div>
          </div>
        </>
      ),
    },
  ];

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <>
      {/* <!-- ====================================== About Section Three ===================================== --> */}
      <section className="section-three overflow-hidden" id="explore-me">
        <div className="container">
          <div className="row services-section">
            <div className="col-xxl-4 col-xl-4 col-lg-4">
              <p className="our-services" data-aos="fade-up">
                COMPANY PROFILE
              </p>
              <h2 className="our-solution" data-aos="fade-up">
                Discover Marichi Tech AI
              </h2>
              <p className="uran odio" data-aos="fade-up">
                Marichi Tech AI is a future-focused IT solutions company
                specializing in web development, mobile applications, and cloud
                infrastructure. We empower businesses with intelligent,
                scalable, and user-centric digital products that drive
                innovation and growth.
              </p>

              {/* <div className="services-circle-main">
                <div
                  className="view-work-circle btn btn1"
                  id="circle1"
                  data-aos="zoom-in-right"
                >
                  <Link to="/portfolio" className="a1">
                    VIEW MY WORK
                  </Link>
                </div>
                <div className="contact-circle" data-aos="zoom-in-left">
                  <div className="view-work-circle btn btn2">
                    <Link to="/contact">CONTACT ME</Link>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="col-xxl-7 col-xl-7 col-lg-7">
              <div id="faq-sec">
                {data.map((item, index) => (
                  <div
                    className="nested-accordion"
                    key={index}
                    data-aos="fade-up"
                  >
                    <h3
                      className={`boder-top ${
                        activeIndex === index ? "selected" : ""
                      }`}
                      onClick={() => handleClick(index)}
                    >
                      {item.title}
                    </h3>
                    <div
                      className="comment"
                      style={{
                        display: activeIndex === index ? "block" : "none",
                      }}
                    >
                      {item.content}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== About Section Three End ===================================== --> */}
    </>
  );
};
export default SectionThree;
